module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy_sq.95139e72.md";